"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PanelSelectDB = require("../../components/PanelSelectDB/PanelSelectDB");

var _PanelSelectDB2 = _interopRequireDefault(_PanelSelectDB);

var _PanelSelectCamps = require("../../components/PanelSelectCamps/PanelSelectCamps");

var _PanelSelectCamps2 = _interopRequireDefault(_PanelSelectCamps);

var _PanelSelectEstacions = require("../../components/PanelSelectEstacions/PanelSelectEstacions");

var _PanelSelectEstacions2 = _interopRequireDefault(_PanelSelectEstacions);

var _PanelSelectRangTemporal = require("../../components/PanelSelectRangTemporal/PanelSelectRangTemporal");

var _PanelSelectRangTemporal2 = _interopRequireDefault(_PanelSelectRangTemporal);

var _PanelTractarDades = require("../../components/PanelTractarDades/PanelTractarDades");

var _PanelTractarDades2 = _interopRequireDefault(_PanelTractarDades);

var _PanelVisualitzarDades = require("../../components/PanelVisualitzarDades/PanelVisualitzarDades");

var _PanelVisualitzarDades2 = _interopRequireDefault(_PanelVisualitzarDades);

var _PanelMessageError = require("../../components/PanelMessageError/PanelMessageError");

var _PanelMessageError2 = _interopRequireDefault(_PanelMessageError);

var _share = require("../../utils/share");

var _share2 = _interopRequireDefault(_share);

var _NavButtons = require("../../components/NavButtons/NavButtons");

var _NavButtons2 = _interopRequireDefault(_NavButtons);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _PanelContainer = require("./PanelContainer.css");

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //     


var PanelContainer = function (_Component) {
	_inherits(PanelContainer, _Component);

	function PanelContainer(props) {
		_classCallCheck(this, PanelContainer);

		var _this = _possibleConstructorReturn(this, (PanelContainer.__proto__ || Object.getPrototypeOf(PanelContainer)).call(this, props));

		_this.saveToLocal = function () {
			return localStorage.setItem(CONSTANTS.JSON_CONFIG_FILE, JSON.stringify(_this.state.jsonConfig));
		};

		var cachedObject = localStorage.getItem(CONSTANTS.JSON_CONFIG_FILE);
		_this.state = {
			error: "",
			showError: false,
			loading: true,
			jsonConfig: cachedObject ? _extends({}, JSON.parse(cachedObject)) : CONSTANTS.defaultJsonConfig
		};
		_this.child = _react2.default.createRef();
		return _this;
	}

	_createClass(PanelContainer, [{
		key: "resetStateJsonConfig",
		value: function resetStateJsonConfig() {
			localStorage.setItem(CONSTANTS.CACHED_STATIONS_DATA, "[]");
			localStorage.setItem(CONSTANTS.JSON_CONFIG_FILE, JSON.stringify(CONSTANTS.defaultJsonConfig));
			this.setState({ jsonConfig: CONSTANTS.defaultJsonConfig });
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			var _this2 = this;

			var _props = this.props,
			    currentId = _props.currentId,
			    organization = _props.organization;

			if (currentId !== undefined && currentId !== this.state.jsonConfig.apps.editor) {
				_share2.default.loadJsonConfig(CONSTANTS.URL_GENERATE_GEOJSON, currentId).then(function (data) {
					if (data.ok && data.ok === false) {
						_this2.setState({ loading: false, showError: true, error: "Error en recuperar les dades de configuraci\xF3 del visor " + currentId + " al servidor: " + data.message });
					} else {
						_this2.setState({ loading: false, jsonConfig: data }, _this2.saveToLocal.bind(_this2));
					}
				}, function (err) {
					console.log(err);
					_this2.setState({ loading: false, showError: true, error: "Error en recuperar les dades de configuraci\xF3 del visor " + currentId + " al servidor" });
				});
			} else {
				//console.info("estic a l'editor");
				localStorage.clear();
				if (organization && organization !== undefined) {
					this.updateJsonConfig("organization", organization);
				}
			}
		}
	}, {
		key: "componentDidCatch",
		value: function componentDidCatch(errorString, errorInfo) {
			this.setState({
				showError: true,
				error: errorString
			});
		}
	}, {
		key: "updateJsonConfig",
		value: function updateJsonConfig(propName, newData) {
			// console.log('updateJsonConfig', propName, newData)
			var newState = {
				jsonConfig: _extends({}, this.state.jsonConfig)
			};
			var props = propName;
			var data = newData;
			try {
				if (!(propName instanceof Array)) {
					if (newState.jsonConfig[props]) {
						newState.jsonConfig[props] = data;
						this.setState(newState, this.saveToLocal.bind(this));
					}
				} else {
					props.forEach(function (prop, index) {
						newState.jsonConfig[prop] = data[index];
					});
					this.setState(newState, this.saveToLocal.bind(this));
				}
			} catch (err) {
				console.info(err);
			}
		}
	}, {
		key: "renderStepPanel",
		value: function renderStepPanel() {
			var _props2 = this.props,
			    currentStep = _props2.currentStep,
			    organization = _props2.organization;
			var jsonConfig = this.state.jsonConfig;

			switch (currentStep) {
				case CONSTANTS.PAS0_SELECCIO_BD:
					return _react2.default.createElement(_PanelSelectDB2.default, { ref: this.child, data: jsonConfig.data, updateJsonConfig: this.updateJsonConfig.bind(this) });
				case CONSTANTS.PAS1_SELECCIO_RANG:
					return _react2.default.createElement(_PanelSelectRangTemporal2.default, { ref: this.child, timerange: jsonConfig.timerange, data: jsonConfig.data, myStep: CONSTANTS.PAS1_SELECCIO_RANG, updateJsonConfig: this.updateJsonConfig.bind(this) });
				case CONSTANTS.PAS2_SELECCIO_CAMPS:
					return _react2.default.createElement(_PanelSelectCamps2.default, { ref: this.child, selectedfields: new Set(jsonConfig.selectedfields), data: jsonConfig.data, timerange: jsonConfig.timerange, myStep: CONSTANTS.PAS2_SELECCIO_CAMPS, updateJsonConfig: this.updateJsonConfig.bind(this) });
				case CONSTANTS.PAS3_SELECCIO_ESTACIONS:
					return _react2.default.createElement(_PanelSelectEstacions2.default, { ref: this.child, iscat: jsonConfig.iscat, selectedstationsids: jsonConfig.selectedstationsids, data: jsonConfig.data, timerange: jsonConfig.timerange, myStep: CONSTANTS.PAS3_SELECCIO_ESTACIONS, updateJsonConfig: this.updateJsonConfig.bind(this) });
				case CONSTANTS.PAS4_TRACTAMENTDADES:
					return _react2.default.createElement(_PanelTractarDades2.default, { ref: this.child, iscat: jsonConfig.iscat, calcdatafieldsCalculs: jsonConfig.calcdatafieldsCalculs, calcdatafieldsOptions: jsonConfig.calcdatafieldsOptions, timerange: jsonConfig.timerange, calcdatafields: jsonConfig.calcdatafields, selectedfields: jsonConfig.selectedfields, isCSVFile: jsonConfig.data.isCSVFile, myStep: CONSTANTS.PAS4_TRACTAMENTDADES, updateJsonConfig: this.updateJsonConfig.bind(this) });
				case CONSTANTS.PAS5_PINTARDADES:
					return _react2.default.createElement(_PanelVisualitzarDades2.default, { ref: this.child, isNewVisor: this.props.isNewVisor, organization: organization, dataJsonConfig: jsonConfig, myStep: CONSTANTS.PAS5_PINTARDADES, updateJsonConfig: this.updateJsonConfig.bind(this) });
				default:
					return _react2.default.createElement(_PanelSelectDB2.default, { ref: this.child });
			}
		}
	}, {
		key: "goNextStep",
		value: function goNextStep() {
			if (this.child.current.isValid()) {
				try {
					var updatejsoncofig = this.child.current.getJsonconfigState();
					if (updatejsoncofig !== null) {
						this.updateJsonConfig(updatejsoncofig.prop, updatejsoncofig.data);
					}
					var currentStep = this.props.currentStep;

					this.props.updateCurrentStep(currentStep + 1);
				} catch (err) {
					console.info(err);
				}
			}
		}
	}, {
		key: "goPrevStep",
		value: function goPrevStep() {
			var currentStep = this.props.currentStep;

			this.props.updateCurrentStep(currentStep - 1);
		}
	}, {
		key: "renderPanelMessageError",
		value: function renderPanelMessageError() {
			var _this3 = this;

			return _react2.default.createElement(_PanelMessageError2.default, {
				isOpen: this.state.showError,
				errorMessage: this.state.error,
				onClose: function onClose() {
					return _this3.setState({ showError: false, error: "" });
				}
			});
		}
	}, {
		key: "render",
		value: function render() {
			var currentStep = this.props.currentStep;

			if (currentStep === CONSTANTS.PAS5_PINTARDADES) {
				return _react2.default.createElement(
					"div",
					{ className: _PanelContainer2.default.panelContainerPintarDades },
					this.renderPanelMessageError(),
					this.renderStepPanel(),
					_react2.default.createElement(_NavButtons2.default, { goPrevStep: this.goPrevStep.bind(this), disabledNext: true, disabledPrev: false })
				);
			} else {
				return _react2.default.createElement(
					"div",
					{ className: _PanelContainer2.default.panelContainer },
					this.renderPanelMessageError(),
					_react2.default.createElement(
						"div",
						{ className: _PanelContainer2.default.subPanelContainer },
						_react2.default.createElement(
							_semanticUiReact.Header,
							null,
							CONSTANTS.STEPS[currentStep].title
						),
						this.renderStepPanel()
					),
					_react2.default.createElement(_NavButtons2.default, { disabledNext: false, disabledPrev: currentStep === 0, goNextStep: this.goNextStep.bind(this), goPrevStep: this.goPrevStep.bind(this) })
				);
			}
		}
	}]);

	return PanelContainer;
}(_react.Component);

exports.default = PanelContainer;

PanelContainer.propTypes = {
	currentStep: _propTypes2.default.number.isRequired,
	currentId: _propTypes2.default.string,
	isNewVisor: _propTypes2.default.bool,
	organization: _propTypes2.default.string,
	updateCurrentStep: _propTypes2.default.func
};
